var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-subpatient","size":"xl","title":`Pilih Sub Pasien Dari ${_vm.patientName}`,"hide-footer":""}},[_c('Table',{attrs:{"patientId":_vm.patientId},on:{"chooseSubPatient":_vm.chosenSubPatient}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }